<template>
  <div class="cd-section" id="features">
    <!--     *********     FEATURES 3      *********      -->
    <div class="features-3">
      <div class="container">
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto">
            <h2 class="title">개인정보처리방침</h2>
            <h5 class="description jipvio-text-left">
              집비오부동산중개(이하 “회사”라 함)은 이용자의 개인정보를 소중하게
              생각하고, 보호하기 위하여 항상 최선을 다해 노력하고 있습니다.
              회사는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」을 비롯한
              모든 개인정보보호 관련 법률규정을 준수하고 있으며, 관련 법령에
              의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고
              있습니다. 또한 「개인정보처리방침」을 제정하여 이를 준수하고
              있으며, 이를 인터넷사이트에 공개하여 이용자가 언제나 용이하게
              열람할 수 있도록 하고 있습니다.
            </h5>
            <!--1조-->
            <h4 class="info-title jipvio-text-left">1. 개인정보의 처리 목적</h4>
            <h5 class="description jipvio-text-left">
              집비오부동산중개('www.jipvio.com, www.jipvio.co.kr'이하
              "회사")은(는) 개인정보를 다음의 목적을 위해 처리합니다. 처리한
              개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이
              변경될 시에는 사전동의를 구할 예정입니다.
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              가. 홈페이지 회원가입 및 관리
              <ul class="pl-15" style="list-style:none;">
                <li>
                  회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증,
                  회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인,
                  서비스 부정이용 방지, 만14세 미만 아동 개인정보 수집 시
                  법정대리인 동의 여부 확인, 각종 고지·통지, 고충처리, 분쟁
                  조정을 위한 기록 보존 등을 목적으로 개인정보를 처리합니다.
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              나. 민원사무 처리
              <ul class="pl-15" style="list-style:none;">
                <li>
                  민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지,
                  처리결과 통보 등을 목적으로 개인정보를 처리합니다.
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              다. 재화 또는 서비스 제공
              <ul class="pl-15" style="list-style:none;">
                <li>
                  서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증,
                  연령인증, 요금결제·정산 등을 목적으로 개인정보를 처리합니다.
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              라. 마케팅 및 광고에의 활용
              <ul class="pl-15" style="list-style:none;">
                <li>
                  신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성
                  정보 제공 및 참여기회 제공 , 인구통계학적 특성에 따른 서비스
                  제공 및 광고 게재 , 서비스의 유효성 확인, 접속빈도 파악 또는
                  회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를
                  처리합니다.
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              마. 개인영상정보
              <ul class="pl-15" style="list-style:none;">
                <li>
                  범죄의 예방 및 수사, 시설안전 및 화재예방 등을 목적으로
                  개인정보를 처리합니다.
                </li>
              </ul>
            </h5>
            <!--2조-->
            <h4 class="info-title jipvio-text-left">2. 개인정보 파일 현황</h4>
            <h5 class="description jipvio-text-left pl-10">
              <ul class="pl-15" style="list-style: square;">
                <li>
                  개인정보 파일명 : 개인정보처리방침
                </li>
                <li>
                  개인정보 항목 : 이메일, 휴대전화번호, 자택주소, 자택전화번호,
                  비밀번호 질문과 답, 비밀번호, 로그인ID, 성별, 생년월일, 이름,
                  취미, 주민등록번호, 신용카드정보, 은행계좌정보, 서비스 이용
                  기록, 접속 로그, 쿠키, 접속 IP 정보, 결제기록, 법정대리인
                  이름, 법정대리인 자택 전화번호, 법정대리인 자택 주소,
                  법정대리인 휴대전화번호
                </li>
                <li>
                  수집방법 : 홈페이지, 서면양식, 전화/팩스, 생성정보 수집 툴을
                  통한 수집
                </li>
                <li>
                  보유근거 : 개인정보처리방침
                </li>
                <li>
                  보유기간 : 회원탈퇴 시 즉시 삭제합니다. 단, 관련법령에 따른
                  보관 의무가 있을 경우 해당 기간 동안 보유합니다.
                </li>
                <li>
                  관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년,
                  소비자의 불만 또는 분쟁처리에 관한 기록 : 3년, 대금결제 및
                  재화 등의 공급에 관한 기록 : 5년, 계약 또는 청약철회 등에 관한
                  기록 : 5년, 표시/광고에 관한 기록 : 6개월
                </li>
              </ul>
            </h5>
            <!--3조-->
            <h4 class="info-title jipvio-text-left">
              3. 개인정보의 처리 및 보유 기간
            </h4>
            <h5 class="description jipvio-text-left">
              ① "회사는" 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터
              개인정보를 수집시에 동의 받은 개인정보 보유, 이용기간 내에서
              개인정보를 처리, 보유합니다.
            </h5>
            <h5 class="description jipvio-text-left">
              ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"><홈페이지 회원가입 및 관리></span>
              <ul class="pl-15" style="list-style: square;">
                <li style="list-style: none;">
                  <홈페이지 회원가입 및 관리>와 관련한 개인정보는 수집.이용에
                  관한 동의일로부터<3년>까지 위 이용목적을 위하여
                  보유.이용됩니다.
                </li>
                <li>
                  보유근거 : 개인정보처리방침
                </li>
                <li>
                  관련법령 : 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년
                </li>
                <li>
                  예외사유 : 대금결제 및 재화 등의 공급에 관한 기록 또는 계약
                  또는 청약철회 등에 관한 기록이 있을 경우에는 <5년>까지
                  보유합니다.
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"><제화 또는 서비스 제공></span>
              <ul class="pl-15" style="list-style: square;">
                <li style="list-style: none;">
                  <제화 또는 서비스 제공>와 관련한 개인정보는 수집.이용에 관한
                  동의일로부터<5년>까지 위 이용목적을 위하여 보유.이용됩니다.
                </li>
                <li>
                  보유근거 : 개인정보처리방침
                </li>
                <li>
                  관련법령 : 대금결제 및 재화 등의 공급에 관한 기록 : 5년
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"><마케팅 및 광고에의 활용></span>
              <ul class="pl-15" style="list-style: square;">
                <li style="list-style: none;">
                  <마케팅 및 광고에의 활용>와 관련한 개인정보는 수집.이용에 관한
                  동의일로부터<6개월>까지 위 이용목적을 위하여 보유.이용됩니다.
                </li>
                <li>
                  보유근거 : 개인정보처리방침
                </li>
                <li>
                  관련법령 : 표시/광고에 관한 기록 : 6개월
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"><개인영상정보></span>
              <ul class="pl-15" style="list-style: square;">
                <li style="list-style: none;">
                  <개인영상정보>와 관련한 개인정보는 수집.이용에 관한
                  동의일로부터<6개월>까지 위 이용목적을 위하여 보유.이용됩니다.
                </li>
                <li>
                  보유근거 : 개인정보처리방침
                </li>
                <li>
                  관련법령 : 표시/광고에 관한 기록 : 6개월
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"><민원사무 처리></span>
              <ul class="pl-15" style="list-style: square;">
                <li style="list-style: none;">
                  <민원사무 처리>와 관련한 개인정보는 수집.이용에 관한
                  동의일로부터<3년>까지 위 이용목적을 위하여 보유.이용됩니다.
                </li>
                <li>
                  보유근거 : 개인정보처리방침
                </li>
                <li>
                  관련법령 : 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"
                ><부동산 매물 등록 및 계약서에 관한 기록></span
              >
              <ul class="pl-15" style="list-style: square;">
                <li style="list-style: none;">
                  <부동산 매물 등록 및 계약서에 관한 기록>와 관련한 개인정보는
                  수집.이용에 관한 동의일로부터 최대 <5년>까지 위 이용목적을
                  위하여 보유.이용됩니다.
                </li>
                <li>
                  보유근거 : 개인정보처리방침
                </li>
                <li>
                  관련법령 : 공인중개사법에 따른 보관 의무
                  (중개대상물확인·설명서 및 전속중개계약서: 3년, 거래계약서 :
                  5년)
                </li>
              </ul>
            </h5>
            <!--4조-->
            <h4 class="info-title jipvio-text-left">
              4. 개인정보의 제3자 제공에 관한 사항
            </h4>
            <h5 class="description jipvio-text-left pl-10">
              회사는 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법
              제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게
              제공합니다.<br />
              다만, 다음의 경우에는 개인정보를 제3자에게 제공할 수 있습니다.
              <ul class="pl-15" style="list-style: none;">
                <li>
                  ① 회사가 제공하는 서비스를 통하여 거래가 성사된 경우, 거래
                  당사자간의 원활한 의사소통을 위하여 관련된 정보를 필요한 범위
                  내에서 거래당사자에게 제공하는 경우
                </li>
                <li>
                  ② 통계작성, 학술연구나 시장조사를 위해 특정 개인을 식별할 수
                  없는 형태로 가공하여 제공하는 경우
                </li>
                <li>
                  ③ 이용자들이 사전에 동의한 경우
                </li>
                <li>
                  ④ 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와
                  방법에 따라 수사기관의 요구가 있는 경우
                </li>
              </ul>
            </h5>
            <!--5조-->
            <h4 class="info-title jipvio-text-left">5. 개인정보처리 위탁</h4>
            <h5 class="description jipvio-text-left pl-10">
              ① 회사는 서비스 제공의 안정성과 보안 등 최신 기술을 이용자에게
              제공하기 위해 국외에 개인정보를 위탁하고 있으며, 이용자로부터 취득
              또는 생성한 개인정보를 AWS (Amazon Web Services Inc.)가 보유하고
              있는 데이터베이스에 저장합니다. AWS는 해당 서버의 물리적인
              관리만을 행하고, 이용자의 개인정보에 접근할 수 없습니다.
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"><개인정보 위탁></span>
              <ul class="pl-15" style="list-style: square;">
                <li>
                  위탁받는 자 (수탁자) : Amazon Web Services Inc.
                </li>
                <li>
                  위탁하는 업무의 내용 : 서비스 이용 기록 또는 수집된 개인정보
                </li>
                <li>
                  서비스 변경 시까지(현재 회사가 이용 중인 클라우드 서비스 이용
                  변경 시까지)
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              ② 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본
              개인정보 처리방침을 통하여 공개합니다.
            </h5>
            <!--6조-->
            <h4 class="info-title jipvio-text-left">
              6. 이용자의 권리∙의무 및 행사방법
            </h4>
            <h5 class="description jipvio-text-left pl-10">
              ① 정보주체와 법정대리인의 권리·의무 및 그 행사방법 이용자는
              개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.
              <ul class="pl-15" style="list-style: square;">
                <li>
                  정보주체는 "회사"에 대해 언제든지 개인정보 열람, 정정, 삭제,
                  처리정지 요구 등의 권리를 행사할 수 있습니다.
                </li>
                <li>
                  제1항에 따른 권리 행사는 "회사"에 대해 개인정보 보호법 시행령
                  제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여
                  하실 수 있으며 "회사" 이에 대해 지체 없이 조치하겠습니다.
                </li>
                <li>
                  제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은
                  자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보
                  보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야
                  합니다.
                </li>
                <li>
                  개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항,
                  제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.
                </li>
                <li>
                  개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가
                  수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수
                  없습니다.
                </li>
                <li>
                  "회사"는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구,
                  처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한
                  대리인인지를 확인합니다.
                </li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              ② 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본
              개인정보 처리방침을 통하여 공개합니다.
            </h5>
            <!--7조-->
            <h4 class="info-title jipvio-text-left">7. 개인정보의 파기</h4>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"><파기절차></span><br />
              이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우
              별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후
              혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한
              경우가 아니고서는 다른 목적으로 이용되지 않습니다.
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"><파기기한></span><br />
              이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는
              보유기간의 종료일로부터 5일 이내에, 개인정보의 처리 목적 달성,
              해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을
              때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일
              이내에 그 개인정보를 파기합니다.
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              <span style="font-weight: 500;"><파기방법></span><br />
              전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을
              사용합니다.
            </h5>
            <!--8조-->
            <h4 class="info-title jipvio-text-left">
              8. 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항
            </h4>
            <h5 class="description jipvio-text-left pl-10">
              ① "회사"는 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고
              수시로 불러오는 ‘쿠기(cookie)’를 사용합니다.
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              ② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의
              컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC
              컴퓨터내의 하드디스크에 저장되기도 합니다. 가. 쿠키의 사용 목적 :
              이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태,
              인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보
              제공을 위해 사용됩니다. 나. 쿠키의 설치•운영 및 거부 : 웹브라우저
              상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키
              저장을 거부 할 수 있습니다. 다. 쿠키 저장을 거부할 경우 맞춤형
              서비스 이용에 어려움이 발생할 수 있습니다.
            </h5>
            <!--9조-->
            <h4 class="info-title jipvio-text-left">
              9. 개인정보 보호책임자 작성
            </h4>
            <h5 class="description jipvio-text-left pl-10">
              ① "회사"는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
              처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와
              같이 개인정보 보호책임자를 지정하고 있습니다.
              <br /><br /><span style="font-weight: 500;"
                ><개인정보 보호책임자></span
              >
              <ul class="pl-15" style="list-style: square;">
                <li>성명: 유소현</li>
                <li>직책: 대표</li>
                <li>직급: 대표</li>
                <li>연락처 :02-2688-3244, cs@jipvio.com</li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              ② 정보주체께서는 "회사"의 서비스(또는 사업)을 이용하시면서 발생한
              모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을
              개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. "회사"는
              정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
            </h5>
            <!--10조-->
            <h4 class="info-title jipvio-text-left">
              10. 개인정보의 안전성 확보조치
            </h4>
            <h5 class="description jipvio-text-left pl-10">
              "회사"는 회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실,
              도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과
              같은 기술적∙관리적∙물리적 조치를 취하고 있습니다.
              <ul class="pl-15" style="list-style: square;">
                <li>
                  정기적인 자체 감사 실시 <br />
                  개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로
                  자체 감사를 실시하고 있습니다.
                </li>
                <li>성명: 유소현</li>
                <li>직책: 대표</li>
                <li>직급: 대표</li>
                <li>연락처 :02-2688-3244, cs@jipvio.com</li>
              </ul>
            </h5>
            <h5 class="description jipvio-text-left pl-10">
              ② 정보주체께서는 "회사"의 서비스(또는 사업)을 이용하시면서 발생한
              모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을
              개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. "회사"는
              정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
            </h5>
            <!--11조-->
            <h4 class="info-title jipvio-text-left">11. 권익침해 구제방법</h4>
            <h5 class="description jipvio-text-left pl-10">
              개인정보에 관한 권익을 침해 당한 경우, 개인정보 침해신고센터,
              대검찰청 컴퓨터 등 첨단범죄 신고, 사이버경찰청 등으로 문의하실 수
              있습니다.
              <ul class="pl-15" style="list-style: square;">
                <li>
                  개인정보 침해신고센터 <br />- 전화번호: 118 <br />- 홈페이지:
                  privacy.kisa.or.kr
                </li>
                <li>
                  개인정보 분쟁조정위원회 <br />- 전화번호: 1833-6972 <br />-
                  홈페이지: www.kopico.go.kr
                </li>
                <li>
                  대검찰청 사이버범죄수사단 <br />- 전화번호 : 1301 <br />-
                  홈페이지 : www.spo.go.kr
                </li>
                <li>
                  경찰청 사이버안전지킴이 <br />- 전화번호 : 182 <br />-
                  홈페이지 : popce.go.kr/www/security/cyber.jsp
                </li>
              </ul>
            </h5>
          </div>
        </div>
        <!--<div class="row">
                    <div class="col-md-4">
                        <div class="info info-hover">
                            <div class="icon icon-success icon-circle">
                                <i class="now-ui-icons objects_globe"></i>
                            </div>
                            <h4 class="info-title">Asset Management</h4>
                            <p class="description">Cross-account dashboards provide sophisticated reporting for enterprise.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="info info-hover">
                            <div class="icon icon-info icon-circle">
                                <i class="now-ui-icons education_atom"></i>
                            </div>
                            <h4 class="info-title">Resource Utilization</h4>
                            <p class="description">CloudCheckr provides summary and detailed usage statistics for resources.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="info info-hover">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons tech_watch-time"></i>
                            </div>
                            <h4 class="info-title">Self-Healing</h4>
                            <p class="description">CloudCheckr enables users to save money, time, and effort.</p>
                        </div>
                    </div>
                </div>-->
      </div>
    </div>
    <!--     *********    END FEATURES 3      *********      -->
  </div>
</template>

<script>
import FeaturesSection from "@/pages/sections/Features";
export default {
  name: "Privacy",
  components: {
    FeaturesSection,
  },

  methods: {},
};
</script>

<style></style>
